import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SecuritiesTransferListItemNormalized } from '../../../../../../../store/customerDetail/SecuritiesTransfer/types';

import { TransferRequestsItemDesktop } from './desktop';
import { TransferRequestsItemMobile } from './mobile';

export interface TransferRequestsItemProps {
  item: SecuritiesTransferListItemNormalized;
  loading: boolean;
  onPressDetails: (protocolNumber: string) => void;
}

const TransferRequestsItemResponsive: React.FC<TransferRequestsItemProps> = (props) => {
  return useBreakpointValue({
    base: <TransferRequestsItemMobile {...props} />,
    lg: <TransferRequestsItemDesktop {...props} />,
  });
};

export const TransferRequestsItem = React.memo(TransferRequestsItemResponsive);
